const isNotDefined = num => {
  if (typeof num === 'undefined' || num === null) return true;
  return false;
}

const priceRanges = [{
  compareFn: diff => { return diff <= 50 },
  increment: 5,
}, {
  compareFn: diff => { return diff >= 51 && diff <= 150 },
  increment: 10,
}, {
  compareFn: diff => { return diff >= 151 && diff <= 300 },
  increment: 20,
}, {
  compareFn: diff => { return diff >= 301 },
  increment: 50,
}];

const calculatePriceIncrement = (min, max) => {
  if (isNotDefined(min) || isNotDefined(max)) return 5;
  const diff = Number(max) - Number(min);
  const increment = priceRanges
    .filter(price => price.compareFn(diff))
    .reduce((prev, priceRange) => { return priceRange.increment }, 0);
  return increment;
};

export default calculatePriceIncrement;